export default __webpack_public_path__ + "static/media/spinner.7e8a418a.gif";